'use strict';

/**
 * Habilita el soporte lazyload para navegadores antiguos
 *
 * Based on * https://web.dev/articles/browser-level-image-lazy-loading
 */
class Lazyload {
	/**
	 *
	 */
	lazy () {
		const imageCssQuerySelector = 'img[loading="lazy"]:not(.loaded)'
		const imageCallback = ele => {
			ele.src = Lazyload.thumborImage(ele), ele.classList.add('loaded')
		};
		'loading' in HTMLImageElement.prototype ?
			document.querySelectorAll(imageCssQuerySelector).forEach(imageCallback) : Lazyload.lazyTrigger(imageCssQuerySelector, imageCallback)
	}
	
	/**
	 *
	 * @param ele
	 * @returns {string|*}
	 */
	static thumborImage(ele) {
		const thumborHost = 'resizer.iproimg'
		const thumborUrl  = 'https://resizer.iproimg.com/unsafe/filters:format(webp):quality(70)/';
		
		if (!ele.dataset.hasOwnProperty('src'))
			return ele.src
		
		if (0 <= ele.dataset.src.indexOf(thumborHost) || 0 <= ele.dataset.src.indexOf('gif'))
			return ele.dataset.src;
		
		return thumborUrl + ele.dataset.src
	}
	
	/**
	 * Lazyload para navegadores que no soportan loading
	 *
	 * @param cssQuerySelector
	 * @param callback
	 */
	static lazyTrigger (cssQuerySelector='', callback = () => {}, percent = 40) {
		if ("IntersectionObserver" in window) {
			const lazyObserver = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.target.classList.hasOwnProperty('loaded')) return;
					if (!entry.isIntersecting) return;
					observer.unobserve(entry.target);
					entry.target.classList.add('loaded');
					callback(entry.target);
				})
			}, {
				rootMargin: percent + '%'
			});
			document.querySelectorAll(cssQuerySelector).forEach(item => lazyObserver.observe(item));
		} else {
			var limit = window.innerHeight + ((window.innerHeight * percent ) / 100) // 35% before visible area
			
			var items = document.querySelectorAll(cssQuerySelector)
			items.forEach(item => {
				if (item.getBoundingClientRect().top < limit) {
					if (item.classList.hasOwnProperty('loaded')) return;
					item.classList.add('loaded');
					callback(item);
				}
			})
		}
	}
	
	/**
	 * Inicializa la funcionalidad del lazy load
	 */
	start ()
	{
		this.lazy()
		window.addEventListener('scroll', this.lazy, false);
	}
	
	/**
	 * Inicializa un comportamiento de tipo Lazyload
	 */
	create(querySelector, callback)
	{
		window.addEventListener('load', function () {
			Lazyload.lazyTrigger(querySelector, callback);
		}, false);
		window.addEventListener('scroll', function () {
			Lazyload.lazyTrigger(querySelector, callback);
		}, false);
	}
}

export default new Lazyload();
